export default "__VITE_ASSET__BlrWAL59__"